var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Directory', _vm._b({
    staticClass: "companies",
    on: {
      "text-input": function($event) {
        _vm.filterValues.input_text = $event
      },
      "clear-all": _vm.clearAllFilters,
      "clear-filter": _vm.clearFilter,
      "more-click": _vm.fetchNextPage
    }
  }, 'Directory', {
    activeFilters: _vm.activeFilters,
    inputText: _vm.filterValues.input_text,
    isLoading: _vm.isLoading,
    results: _vm.results,
    resultCount: _vm.resultCount,
    unitLabels: _vm.unitLabels,
  }, false), [_c('div', {
    staticClass: "companies__filters-list",
    slot: "filters"
  }, [_c('div', {
    staticClass: "companies__filters-line-1"
  }, [_vm._l((_vm.filters), function(filter) {
    return _c('CmSelect', {
      key: filter.id,
      staticClass: "companies__filter companies__filter--select",
      attrs: {
        "name": filter.id,
        "options": filter.options,
        "null-label": filter.nullLabel,
        "label": filter.label,
        "multiple": filter.multiple,
        "include-search": filter.options.length > 12,
        "value": _vm.filterValues[filter.id],
        "compact": ""
      },
      on: {
        "input": function($event) {
          _vm.filterValues[filter.id] = $event
        }
      }
    })
  }), _vm._v(" "), _c('LocationFilter', {
    staticClass: "companies__filter companies__filter--select",
    attrs: {
      "location": _vm.filterValues.location,
      "radius": _vm.filterValues.radius
    },
    on: {
      "location": function($event) {
        _vm.filterValues.location = $event
      },
      "coords": function($event) {
        _vm.filterValues.coords = $event
      },
      "radius": function($event) {
        _vm.filterValues.radius = $event
      }
    },
    model: {
      value: (_vm.filterValues.location),
      callback: function($$v) {
        _vm.filterValues.location = $$v
      },
      expression: "filterValues.location"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "companies__filter companies__filter--checkbox",
    attrs: {
      "label": "Hiring!"
    },
    model: {
      value: (_vm.filterValues.is_hiring),
      callback: function($$v) {
        _vm.filterValues.is_hiring = $$v
      },
      expression: "filterValues.is_hiring"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "companies__filter companies__filter--checkbox",
    attrs: {
      "label": "My Favorites"
    },
    model: {
      value: (_vm.filterValues.is_favorite),
      callback: function($$v) {
        _vm.filterValues.is_favorite = $$v
      },
      expression: "filterValues.is_favorite"
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "companies__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('CompanyCard', {
      key: result.id,
      staticClass: "companies__job",
      attrs: {
        "liked": _vm.dynamicFavorites.includes(result.id),
        "company": result,
        "is-logged-in": _vm.isLoggedIn
      },
      on: {
        "like": _vm.likeCompany,
        "unlike": _vm.unlikeCompany
      }
    })
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0354100f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/pages/companies.vue
// module id = null
// module chunks = 